import { get, writable } from 'svelte/store';

const STORAGE_KEY = 'shelly_dev_glass_blur';

const readInitialValue = (): boolean => {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		// Default on — matches Theme `glassBlur` default / production glass surfaces.
		if (stored === null) return true;
		return stored === 'true';
	} catch {
		return true;
	}
};

/**
 * Dev-only toggle for design-system glass backdrop blur.
 * Fed into `<Theme glassBlur={...} />`. Preference is saved locally.
 */
export const glassBlurEnabled = writable<boolean>(readInitialValue());

glassBlurEnabled.subscribe((value) => {
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const isGlassBlurEnabled = (): boolean => get(glassBlurEnabled);

export const setGlassBlurEnabled = (enabled: boolean) => {
	glassBlurEnabled.set(enabled);
};
